import React, { useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { ChevronLeft, ChevronRight } from "lucide-react";
import gsap from "utils/gsap";

const Paginations = ({ currentPage, totalPages, onPageChange, totalCount ,className="" }) => {
  const { t } = useTranslation();
  const paginationRef = useRef(null);


  const pages = useMemo(() => {
    if (totalPages <= 1) return [1];

    const range = 2;
    const pagesArr = [];
    const start = Math.max(1, currentPage - range);
    const end = Math.min(totalPages, currentPage + range);

    if (start > 1) pagesArr.push(1);

    if (start > 2) pagesArr.push("...");

    for (let i = start; i <= end; i++) {
      pagesArr.push(i);
    }

    if (end < totalPages - 1) pagesArr.push("...");

    if (end < totalPages) pagesArr.push(totalPages);

    return pagesArr;
  }, [currentPage, totalPages]);

  useEffect(() => {
    if (!paginationRef.current) return;

    gsap.fromTo(
      paginationRef.current,
      { opacity: 0, y: 6 },
      {
        opacity: 1,
        y: 0,
        duration: 0.25,
        ease: "power2.out",
        delay: 0.2,
      },
    );
  }, [currentPage]);

  if (!totalCount) return null;

  return (
    <Row className={`custom_pagination my-4 ${className}`} ref={paginationRef}>
      <Col sm={12}>
        <div className="g_between pagination_content_wrapper">
          <h6 className="total_record_text">
            {t("Total Records")}: <span>{totalCount}</span>
          </h6>
          <ul className="pagination">
            <li className={`page-item forward_paginate ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="transparent_btn"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <ChevronLeft />
              </button>
            </li>

            {pages.map((page, index) =>
              page === "..." ? (
                <li key={`ellipsis-${index}`} className="page-item disabled">
                  <span className="page-link">…</span>
                </li>
              ) : (
                <li
                  key={page}
                  className={`page-item ${
                    currentPage === page ? "active disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => onPageChange(page)}
                  >
                    {page}
                  </button>
                </li>
              ),
            )}

            <li
              className={`page-item backward_paginate ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="transparent_btn"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <ChevronRight />
              </button>
            </li>
          </ul>
        </div>
      </Col>
    </Row>
  );
};

export default Paginations;
